/**
 * Чистая логика WebSocket-уведомлений (без Vue) — удобно тестировать.
 */

import { isNotificationVisibleInERP } from './notificationLogic.mjs'

export function buildMessageServiceWsURL(baseURL, accessToken, { protocol, host } = {}) {
  const token = (accessToken || '').trim()
  if (!token) return null

  const proto = protocol
    || (typeof window !== 'undefined' && window.location?.protocol === 'https:' ? 'wss:' : 'ws:')
  const h = host
    || (typeof window !== 'undefined' ? window.location.host : 'localhost')

  let path = (baseURL || '/message-service').replace(/\/$/, '')
  if (/^https?:\/\//i.test(path)) {
    const u = new URL(path)
    const wsProto = u.protocol === 'https:' ? 'wss:' : 'ws:'
    return `${wsProto}//${u.host}/api/ws?token=${encodeURIComponent(token)}`
  }
  return `${proto}//${h}${path}/api/ws?token=${encodeURIComponent(token)}`
}

export function parseNotificationPayload(raw) {
  let data = raw
  if (typeof raw === 'string') {
    try {
      data = JSON.parse(raw)
    } catch {
      return null
    }
  }
  if (!data || typeof data !== 'object') return null
  if (data.type && data.type !== 'notification') return null
  if (!Object.prototype.hasOwnProperty.call(data, 'content')) return null
  if (!isNotificationVisibleInERP(data)) return null
  const entityIdRaw = data.entity_id
  const entityId = entityIdRaw == null || entityIdRaw === ''
    ? null
    : Number(entityIdRaw)
  return {
    type: data.type || 'notification',
    id: data.id,
    content: String(data.content ?? ''),
    is_read: !!data.is_read,
    is_send: !!data.is_send,
    user_id: data.user_id ?? null,
    role_id: data.role_id ?? null,
    channel_id: data.channel_id ?? null,
    entity_type: data.entity_type ? String(data.entity_type).toLowerCase() : null,
    entity_id: Number.isFinite(entityId) && entityId > 0 ? entityId : null,
    source: data.source ? String(data.source).toLowerCase() : null,
    created_at: data.created_at || null,
    url: typeof data.url === 'string' && data.url.startsWith('/') ? data.url : null,
  }
}

export function notificationToastMessage(payload) {
  if (!payload) return ''
  const text = (payload.content || '').trim()
  if (!text) return 'Новое уведомление'
  return text.length > 180 ? `${text.slice(0, 177)}…` : text
}

export function notificationKind(payload) {
  if (!payload) return 'unknown'
  if (payload.channel_id != null) return 'channel'
  if (payload.role_id != null) return 'role'
  if (payload.user_id != null) return 'personal'
  return 'unknown'
}

/**
 * Vue Router location для deep-link из уведомления.
 * Домен хранит entity_type/entity_id; UI знает маршруты.
 * @returns {{ name: string, params: { id: string } } | null}
 */
export function notificationRoute(payload) {
  if (!payload) return null
  const type = (payload.entity_type || '').toLowerCase()
  const id = Number(payload.entity_id)
  if (!type || !Number.isFinite(id) || id <= 0) return null

  const routeByEntity = {
    trip: 'CargoDetail',
    executor: 'ExecutorsDetail',
    car: 'CarDetail',
    trailer: 'CarDetail', // прицепы живут в /cars/:id
    driver: 'DriverDetail',
  }
  const name = routeByEntity[type]
  if (!name) return null
  return { name, params: { id: String(id) } }
}

/** Путь SPA (для Push notificationclick), тот же mapping что notificationRoute. */
export function notificationPath(payload) {
  const loc = notificationRoute(payload)
  if (!loc) return null
  const id = loc.params.id
  switch (loc.name) {
    case 'CargoDetail':
      return `/trips/${id}`
    case 'ExecutorsDetail':
      return `/executors/${id}`
    case 'CarDetail':
      return `/cars/${id}`
    case 'DriverDetail':
      return `/drivers/${id}`
    default:
      return null
  }
}

export function notificationInboxPath(payload) {
  const path = notificationPath(payload)
  if (path) return path
  const channelId = Number(payload?.channel_id)
  if (Number.isFinite(channelId) && channelId > 0) {
    return `/notifications?section=channels&channelId=${channelId}`
  }
  return '/notifications'
}

export function notificationIsNavigable(payload) {
  return notificationRoute(payload) != null
}
